import { gql } from '@apollo/client'

export const DELETE_ZONES = gql`
  mutation DeleteZones($input: DeleteZonesInput!) {
    deleteZones(input: $input) {
      success
    }
  }
`
